<template>
  <div class="pa-4">
    <h1>alert-msg</h1>
    <v-btn
      class="mr-2 my-2"
      @click="setAlert({ show: true, type: 'success', message: '成功提示'})"
    >
      成功提示
    </v-btn>
    <v-btn
      class="mr-2 my-2"
      @click="setAlert({ show: true, type: 'error', message: '错误提示'})"
    >
      错误提示
    </v-btn>
    <v-btn
      class="mr-2 my-2"
      @click="setAlert({ show: true, type: 'warning', message: '警告提示'})"
    >
      警告提示
    </v-btn>
    <v-btn
      class="mr-2 my-2"
      @click="setAlert({ show: false, type: null, message: null})"
    >
      关闭提示
    </v-btn>
    <p>
      <a href="https://v2.vuetifyjs.com/zh-Hans/components/snackbars/">消息条 (Snackbars)</a>
    </p>
    <CoreSnackbar />
  </div>
</template>

<script>
import CoreSnackbar from './CoreSnackbar.vue';
import { mapMutations } from 'vuex';

export default {
  components: {
    CoreSnackbar,
  },
  methods: {
    ...mapMutations('alertMsg', ['setAlert']),
  },
}
</script>

<style>

</style>